import React from 'react'
import { TabItem } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const tabs = [
  'Organization',
  'Inisiatif',
  'Event',
  'Resource',
  'Blog'
]

const ListNav = ({activeTab, onChange, className}) => {
  const { width } = useViewport()
  const isDesktop = width >= viewportBreakpoint.desktop

  return isDesktop ? (
    <div className={`flex border-b mb-10 ${className}`}>
      {
        tabs.map((t, index) => {
          const className = index === 0 ? '' : 'ml-6'
          return <TabItem
            key={index}
            selected={activeTab}
            onClick={onChange}
            text={t}
            className={`pb-2 ${className}`}
            small
          />
        })
      }
    </div>
  ) : (
    <div className={`flex border-b mb-5 w-full overflow-x-auto ${className}`}>
      {
        tabs.map((t, index) => {
          return <TabItem
            key={index}
            selected={activeTab}
            onClick={onChange}
            text={t}
            className={`whitespace-no-wrap p-4`}
            embed
          />
        })
      }
    </div>
  )
}

export { ListNav }
